module.exports = __webpack_public_path__ + "static/media/storybook-icon.b253751a.svg";